import clsx from 'clsx';

interface ModalContentProps extends BaseProps {}

export const ModalContent = ({
  children,
  className,
  ...rest
}: ModalContentProps) => {
  return (
    <div className={clsx(className, 'p-5')} {...rest}>
      {children}
    </div>
  );
};
